import React from "react";
import "./Title.scss";

export const Title = ({
  Title,
  SpanTitle,
  Description,
}) => {
  return (
    <div className="section-title">
      <div className="section-title-line" />

      <h1>
        {Title && <span className="title-main">{Title}</span>}

        {SpanTitle && (
          <span className="title-accent">
            {SpanTitle}
          </span>
        )}
      </h1>

      {Description && (
        <p>{Description}</p>
      )}
    </div>
  );
};